import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
    return (
        <Sonner
            position="top-left"
            className="toaster group"
            toastOptions={{
                classNames: {
                    toast: 'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
                    description: 'group-[.toast]:text-muted-foreground',
                    actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
                    cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
                    success: '!bg-[rgb(63,182,142)] !text-white !border-[rgb(50,145,114)]',
                    info: '!bg-[rgb(59,130,246)] !text-white !border-[rgb(37,99,235)]',
                    error: '!bg-[rgb(220,38,38)] !text-white !border-[rgb(185,28,28)]',
                },
            }}
            {...props}
        />
    )
}

export { Toaster }
